export default __webpack_public_path__ + "static/media/img2.05fcb9db.png";